import React from 'react';
import menu from 'constants/menu';
import { Link } from 'react-router-dom';
import { MeetingRoomOutlined } from '@mui/icons-material';
import { useAuth } from 'context/AuthContext';

const AppSidebar = ({ activePage }) => {
  const { setUser } = useAuth();

  const signOut = () => {
    setUser(false);
    localStorage.removeItem('user');
  };

  return (
    <div className="w-full flex flex-col items-center justify-between">
      <div className="flex items-center justify-center">
        <img src="/logo.png" alt="Maç Toplantısı" width={160} height="auto" />
      </div>
      <div className="flex flex-col w-full">
        <div className="text-sm mb-4 font-semibold text-gray-400">Menü</div>
        {menu.map((item, index) =>
          item.isVisible ? (
            <Link
              to={item.path}
              key={index}
              className={`mb-2 flex items-center hover:bg-gray-700 hover:text-gray-200 px-3 py-2 rounded-md transition-all ${
                activePage.mainPath === item.mainPath ? 'bg-gray-700 text-gray-200' : 'text-gray-400'
              }`}
            >
              <item.Icon
                fontSize="small"
                className={`${item.icon} mr-4`}
              ></item.Icon>
              <span className="font-medium">{item.name}</span>
            </Link>
          ) : (
            <div key={index}></div>
          )
        )}
        <div
          className="text-gray-400 mb-2 flex items-center hover:bg-gray-700 hover:text-gray-200 px-3 py-2 rounded-md transition-all cursor-pointer"
          onClick={signOut}
        >
          <MeetingRoomOutlined
            className="mr-4"
            fontSize="small"
          />
          <span className="font-medium">Çıkış Yap</span>
        </div>
      </div>
      <div className="flex text-sm text-gray-400">
        {new Date().getFullYear()} © Admin Panel
      </div>
    </div>
  );
};

export default AppSidebar;
